export const NAME = "modalsModule" as string;

export const GLOBAL_CONFIRM_MODAL_ID = "GlobalConfirmModal";
